import { useMemo } from 'react';

export const FALLBACK_TITLE = document.title;

export function useUpdatePageTitle() {
  function handleUpdatePageTitle(title = FALLBACK_TITLE) {
    document.title = title;
  }

  return useMemo(() => ({ handleUpdatePageTitle }), []);
}
